import { Injectable, Pipe, PipeTransform } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'formatSharedWith',
})
export class FormatSharedWithPipe implements PipeTransform {
  transform(sharedWith: string[]): string {
    if (sharedWith && sharedWith.length > 0) {
      const userSubs = sharedWith.map((item) => item).join('; ')
      return userSubs
    }
    return ''
  }
}
